import React from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import Icon, { IconOwnProps } from '@mui/material/Icon';
import { styled } from '@mui/material/styles';

interface StyledIconProps {
  color?: 'primary' | 'error';
}

const StyledIcon = styled(Icon)<StyledIconProps>(({ color, fontSize }) => ({
  marginLeft: '5px  !important',
  marginBottom: '2px  !important',

  '& svg': {
    fontSize: fontSize || '18px !important',
    color: color || 'inherit',
    verticalAlign: 'inherit',
  },
}));

interface IconTooltipProps extends Omit<TooltipProps, 'children' | 'title'> {
  icon: React.ReactNode;
  color?: 'primary' | 'error';
  fontSize?: IconOwnProps['fontSize'];
  title: React.ReactNode;
}

const IconTooltip: React.FC<IconTooltipProps> = ({ icon, color, fontSize, title, placement, ...rest }) => {
  return (
    <Tooltip
      {...rest}
      title={<div style={{ whiteSpace: 'pre-line' }}>{title}</div>}
      placement={placement}
      arrow={rest.arrow ?? false}
      slotProps={{
        ...rest.slotProps,
        popper: {
          ...rest.slotProps?.popper,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}
    >
      <StyledIcon color={color} fontSize={fontSize} sx={{ overflow: 'unset !important' }}>
        {icon}
      </StyledIcon>
    </Tooltip>
  );
};

export default IconTooltip;
